import React, { Fragment, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { StyleRoot } from "radium";
import layoutRoutes from "./routes/index.jsx";
import themes from "config/themes";
import { themeConfig } from "config";
import { PersistGate } from "redux-persist/integration/react";
import setupTokenRefresh from "./redux/auth/authTokenRefresher";
import LandingRouter from "pages/landing/LandingRouter";
import LanguageProvider from "./contexts/LanguageContext";
import GlobalModal from "components/ui/GlobalModal/GlobalModal";
import "./assets/scss/app.scss";
import "pretty-checkbox/src/pretty-checkbox.scss";

// CORREÇÃO: Importando addLocaleData e os dados de cada idioma
import { addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import pt from "react-intl/locale-data/pt";
import es from "react-intl/locale-data/es";

// CORREÇÃO: Adicionando os dados de localização à biblioteca
addLocaleData([...en, ...pt, ...es]);

const App = () => {
  useEffect(() => {
    setupTokenRefresh();
  }, []);

  const landingPaths = [
    "/",
    "/sobre",
    "/praticidade",
    "/interatividade",
    "/analise"
  ];

  const LayoutComponent = layoutRoutes.find((r) => r.path === "/")?.component;

  return (
    <Fragment>
      <LanguageProvider>
        <ThemeProvider theme={themes[themeConfig.theme]}>
          <StyleRoot>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                  <GlobalModal />
                  <Routes>
                    {landingPaths.map((path) => (
                      <Route
                        key={path}
                        path={path}
                        element={<LandingRouter />}
                      />
                    ))}
                    {layoutRoutes
                      .filter((r) => r.path !== "/")
                      .map((prop, key) => (
                        <Route
                          key={key}
                          path={prop.path}
                          element={React.createElement(prop.component)}
                        />
                      ))}
                    {LayoutComponent && (
                      <Route
                        path="/*"
                        element={React.createElement(LayoutComponent)}
                      />
                    )}
                  </Routes>
                </BrowserRouter>
              </PersistGate>
            </Provider>
          </StyleRoot>
        </ThemeProvider>
      </LanguageProvider>
    </Fragment>
  );
};

export default App;
